import React, { Component } from 'react';
import { connect } from 'react-redux';
import { alert, infoAd } from '../../../Images/Images';

class AlertWindow extends Component{

   // PROPS:
  // title: Titulo de la ventana
  // btnYesStyle : Clase con el estilo para boton si
  // btnNoStyle : Clase con el estilo para boton no
  // btnNo=Titulo para boton no
  // btnYes=Titulo para boton si
  // body: Cuerpo de la alerta
  // onYes=Callback para clic en yes
  // onNo=CallBack para clic en no
  // isGlobe: True - vista de globo False - Vista normal
  // isInfo: True - ícono de alerta | False - Vista ícono de información

  constructor(props){
    super(props);
    this.state = {

    }
  }
  
  render() {
    return (
      <div className={this.props.isGlobe ? "alertGlobe" : "alertSquare" }>
        <div className={this.props.isGlobe ? "headerGlobe" : "headerSquare" }>
        {this.props.isInfo? 
        <i id='AW-icon-warning'className='gcl-icon warning' /> :
        <img className="alertIcon" src={alert } alt="icon"></img>}
          <p className="titleAlert">{this.props.title}</p>
        </div>
        <div className="bodyAlert">
          {this.props.body}
        </div>
        {this.props.onYes &&
        <div className={this.props.btnYesStyle ? this.props.btnYesStyle : "alertBtn btnYes"} onClick={()=>this.props.onYes()}>{ this.props.btnYes }</div>
         }
       { this.props.onNo &&
        <div className={this.props.btnNoStyle ? this.props.btnNoStyle : "alertBtn btnNo"} onClick={()=>this.props.onNo()}>{ this.props.btnNo }</div>
        }
      </div>
    );
  }
}

export default AlertWindow = connect(
  null,
  null
)(AlertWindow);



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/AlertWindow.jsx